<!-- <ng-container
  *ngIf="
    (config.multiple && !config.list) ||
    (config.multiple && config.list && isEmpty(resource))
  "
> -->
<ng-container *ngIf="config.multiple && !config.list">
  <mat-chip-list>
    <mat-chip
      [selected]="hasDefault && res.id === defaultValue?.id"
      (click)="selectDefault(res)"
      *ngFor="let res of resource; let i = index"
      (removed)="removeAt(i)"
    >
      <span *ngFor="let display of config.display; let last = last">
        {{ res | displayData : display.path : display }}
        {{ last ? "" : " - " }}
      </span>
      <button matChipRemove *ngIf="!config.notEditable" type="button">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
    <button
      mat-button
      color="primary"
      (click)="openDialog()"
      type="button"
      *ngIf="!config?.list"
      [disabled]="disabled"
    >
      <mat-icon>add</mat-icon> {{ config.title }}
    </button>
  </mat-chip-list>
</ng-container>

<ng-container *ngIf="!config.multiple && !config.list">
  <ng-container *ngIf="resource; else searchResourceButton">
    <div class="list-item">
      <div class="item">
        <span
          *ngFor="let display of config.display"
          [ngClass]="display.class || 'main'"
        >
          {{ resource | displayData : display.path : display }}
        </span>
      </div>
      <div>
        <button
          mat-icon-button
          type="button"
          (click)="onSelectionChange(null)"
          *ngIf="!config.notEditable"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </ng-container>
  <ng-template #searchResourceButton>
    <div class="button-wrapper">
      <button
        mat-button
        color="primary"
        (click)="openDialog()"
        type="button"
        [disabled]="disabled"
      >
        <mat-icon>add</mat-icon> {{ config.title }}
      </button>
    </div>
  </ng-template>
</ng-container>
<ng-container *ngIf="config.list">
  <mat-form-field>
    <!-- <mat-label>{{ config.title }}</mat-label> -->
    <mat-select
      [(ngModel)]="resource"
      (selectionChange)="onSelectionChange(resource)"
      [multiple]="config.multiple"
      [compareWith]="compare"
    >
    <mat-option [value]="null">
      Empty
    </mat-option>
      <mat-option *ngFor="let res of resources$ | async" [value]="res">
        <span *ngFor="let display of config.display">
          {{ res | displayData : display.path : display }}
        </span>
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-container>
